export default "__VITE_PUBLIC_ASSET__b84410c1__"